/**
 * Brazilian Portuguese (pt-BR) mappings for UpgradeToPro
 */

export const upgradeToProPtBR = {
  // Main titles and headers
  "StarCoins": "StarCoins",
  "Pay-Per-Use AI": "IA Pré-Paga",
  "Get instant access to all premium AI features with StarCoins. No subscription required - just pay for what you use!": "StarCoins são a moeda virtual para uso estendido que nunca expira. Não é necessário assinatura para jogar casualmente, mas oferecemos assinatura Pro para usuários avançados com descontos em moedas! As moedas podem ser usadas para chats extras, giros, quickpicks, ou em nosso mercado para jogadores avançados.",
  "market for advanced gamers": "mercado para jogadores avançados",
  
  // StarCoins section
  "StarCoins System": "Sistema StarCoins",
  "StarCoins are your gateway to unlimited AI-powered sports betting analysis. Purchase coins as needed and use them for advanced features, custom analysis, and extended conversations.": "StarCoins são sua porta de entrada para análises ilimitadas de apostas esportivas com IA. Compre moedas conforme necessário e use-as para recursos avançados, análises personalizadas e conversas estendidas.",
  
  // Star Coins breakdown
  "How Star Coins Work": "Como Funcionam as Star Coins",
  "Star Coins": "Star Coins",
  "= 1 QuickPick": "= 1 QuickPick",
  "= 1 xPicks": "= 1 xPicks",
  "= 1 AI Message": "= 1 Mensagem IA",
  "= 1 Game Prediction": "= 1 Previsão de Jogo",
  "Never Expire": "Nunca Expiram",
  "Use anytime!": "Use quando quiser!",
  "Use PickStar for your sports betting research now or save for later – your Star Coins never expire!": "Use o PickStar para sua pesquisa de apostas esportivas agora ou guarde para depois – suas Star Coins nunca expiram!",
  
  // StarCoin benefits
  "Pay As You Go": "Pague Conforme Usa",
  "Only pay for what you use. No monthly commitments required.": "Pague apenas pelo que usar. Sem compromissos mensais.",
  "Instant Access": "Acesso Instantâneo",
  "Get immediate access to all AI features without subscription.": "Acesso imediato a todos os recursos de IA sem assinatura.",
  "Flexible Usage": "Uso Flexível",
  "Scale up or down based on your betting analysis needs.": "Aumente ou diminua com base em suas necessidades de análise.",
  "Bulk Savings": "Economia em Volume",
  "Save more with larger StarCoin packages. Pro members save up to 50%!": "Economize mais com pacotes maiores. Membros Pro economizam até 50%!",
  
  // Buttons
  "Buy StarCoins Now": "Comprar StarCoins Agora",
  "Learn More": "Saiba Mais",
  "Purchase Star Coins": "Comprar Star Coins",
  "Processing...": "Processando...",
  
  // Purchase section
  "Choose Your Package": "Escolha Seu Pacote",
  "MOST POPULAR": "MAIS POPULAR",
  "POPULAR": "POPULAR",
  "bonus coins": "moedas bônus",
  "per 100 coins": "por 100 moedas",
  "Current Balance": "Saldo Atual",
  "Secure checkout powered by Stripe": "Checkout seguro via Stripe",
  "Error processing payment. Please try again.": "Erro ao processar pagamento. Por favor, tente novamente.",
  
  // Pro section
  "Want Even More Value?": "Quer Ainda Mais Valor?",
  "Upgrade to Pro for built-in usage, discounted StarCoins, and exclusive features": "Atualize para Pro para uso incluído, StarCoins com desconto e recursos exclusivos",
  "Pro Membership": "Assinatura Pro",
  "Pro Benefits Include:": "Benefícios Pro Incluem:",
  
  // Pro benefits
  "4x built-in monthly usage included": "4x de uso mensal incluído",
  "Up to 50% discount on all StarCoin purchases": "Até 50% de desconto em todas as compras de StarCoins",
  "Priority AI processing queue": "Fila prioritária de processamento de IA",
  "Exclusive Pro-only features": "Recursos exclusivos para Pro",
  "Advanced analytics dashboard": "Painel de análises avançado",
  "Priority customer support": "Suporte prioritário ao cliente",
  "$50 worth of usage every month": "R$ 250 em uso todos os meses",
  "Buy StarCoins at UP TO 50% off regular price": "Compre StarCoins com ATÉ 50% de desconto",
  "Never worry about running out mid-analysis": "Nunca se preocupe em ficar sem créditos durante a análise",
  
  // Premium features
  "Premium Features": "Recursos Premium",
  "Advanced capabilities available with both StarCoins and Pro membership": "Capacidades avançadas disponíveis com StarCoins e assinatura Pro",
  
  // Feature titles and descriptions
  "Extended Access & Priority Processing": "Acesso Estendido e Processamento Prioritário",
  "Enjoy significantly higher usage limits with priority queue processing for instant responses. Never wait for AI-powered insights when you need them most.": "Aproveite limites de uso significativamente maiores com processamento prioritário para respostas instantâneas. Nunca espere por insights de IA quando mais precisar.",
  
  "Complete Conversation History": "Histórico Completo de Conversas",
  "Access your entire conversation archive with advanced search capabilities. Find specific insights, strategies, and recommendations from any previous session.": "Acesse todo seu arquivo de conversas com recursos avançados de busca. Encontre insights específicos, estratégias e recomendações de qualquer sessão anterior.",
  
  "Advanced Data Analysis Tools": "Ferramentas Avançadas de Análise de Dados",
  "Upload custom datasets, spreadsheets, and documents for personalized analysis. Transform your raw data into actionable sports betting intelligence.": "Faça upload de conjuntos de dados personalizados, planilhas e documentos para análise personalizada. Transforme seus dados brutos em inteligência acionável para apostas esportivas.",
  
  "Personalized AI Recommendations": "Recomendações Personalizadas de IA",
  "Receive tailored insights based on your betting patterns, preferences, and historical performance. Our AI learns your style to optimize recommendations.": "Receba insights personalizados com base em seus padrões de apostas, preferências e desempenho histórico. Nossa IA aprende seu estilo para otimizar recomendações.",
  
  // Additional benefits
  "Additional Pro Benefits": "Benefícios Pro Adicionais",
  "Everything you need for professional-grade sports analytics and betting intelligence.": "Tudo que você precisa para análises esportivas e inteligência de apostas de nível profissional.",
  
  // Benefit items
  "Priority customer support with dedicated assistance": "Suporte prioritário com assistência dedicada",
  "Early access to new features and beta releases": "Acesso antecipado a novos recursos e versões beta",
  "Advanced analytics dashboard with performance tracking": "Painel de análises avançado com rastreamento de desempenho",
  "Custom prompt templates for specialized analysis": "Modelos de prompt personalizados para análises especializadas",
  "Export capabilities for reports and insights": "Recursos de exportação para relatórios e insights",
  "Enhanced security with premium data protection": "Segurança aprimorada com proteção premium de dados",
  
  // Coming Soon section (TEMPORARY)
  "Pro Subscriptions Coming Soon!": "Assinaturas Pro em Breve!",
  "We're working on something special for power users. Stay tuned for exclusive Pro features and discounts!": "Estamos trabalhando em algo especial para usuários avançados. Fique ligado para recursos e descontos exclusivos Pro!",
  "In the meantime, enjoy unlimited access with StarCoins - pay only for what you use, no subscription needed!": "Enquanto isso, aproveite acesso ilimitado com StarCoins - pague apenas pelo que usar, sem necessidade de assinatura!",

  // Button text
  "Upgrade to Pro": "Atualizar para Pro",
  "View Pricing": "Ver Preços",
  
  // Package display
  "View Packages": "Ver Pacotes",
  "Hide Packages": "Ocultar Pacotes",
  "Choose Your StarCoin Package": "Escolha Seu Pacote de StarCoins",
  "Pro members get 50% off all packages!": "Membros Pro ganham 50% de desconto em todos os pacotes!",
  "Select": "Selecionar",
  "MOST POPULAR": "MAIS POPULAR",
  "Save": "Economize",
  
  // Package names
  "basic": "Básico",
  "value": "Valor",
  "premium": "Premium",
  "ultimate": "Ultimate"
};